/* prettier-ignore */

export const countriesMock = [
  {
    "id": 2,
    "description": "Afeganistão",
    "sigla": "AF",
    "ibge": 132
  },
  {
    "id": 3,
    "description": "Africa do Sul",
    "sigla": "ZA",
    "ibge": 7560
  },
  {
    "id": 4,
    "description": "Albania",
    "sigla": "AL",
    "ibge": 175
  },
  {
    "id": 5,
    "description": "Alemanha",
    "sigla": "DE",
    "ibge": 230
  },
  {
    "id": 6,
    "description": "Andorra",
    "sigla": "AD",
    "ibge": 370
  },
  {
    "id": 7,
    "description": "Angola",
    "sigla": "AO",
    "ibge": 400
  },
  {
    "id": 8,
    "description": "Anguilla",
    "sigla": "AI",
    "ibge": 418
  },
  {
    "id": 9,
    "description": "Antartida",
    "sigla": "AQ",
    "ibge" : 0
  },
  {
    "id": 10,
    "description": "Antigua e Barbuda",
    "sigla": "AG",
    "ibge": 434
  },
  {
    "id": 11,
    "description": "Antilhas Holandesas",
    "sigla": "AN",
    "ibge": 477
  },
  {
    "id": 14,
    "description": "Argentina",
    "sigla": "AR",
    "ibge": 639
  },
  {
    "id": 13,
    "description": "Argélia",
    "sigla": "DZ",
    "ibge": 590
  },
  {
    "id": 15,
    "description": "Armenia",
    "sigla": "AM",
    "ibge": 647
  },
  {
    "id": 16,
    "description": "Aruba",
    "sigla": "AW",
    "ibge": 655
  },
  {
    "id": 12,
    "description": "Arábia Saudita",
    "sigla": "SA",
    "ibge": 531
  },
  {
    "id": 17,
    "description": "Australia",
    "sigla": "AU",
    "ibge": 698
  },
  {
    "id": 18,
    "description": "Austria",
    "sigla": "AT",
    "ibge": 728
  },
  {
    "id": 19,
    "description": "Azerbaijão",
    "sigla": "AZ",
    "ibge": 736
  },
  {
    "id": 20,
    "description": "Bahamas",
    "sigla": "BS",
    "ibge": 779
  },
  {
    "id": 21,
    "description": "Bahrein",
    "sigla": "BH",
    "ibge": 809
  },
  {
    "id": 22,
    "description": "Bangladesh",
    "sigla": "BD",
    "ibge": 817
  },
  {
    "id": 23,
    "description": "Barbados",
    "sigla": "BB",
    "ibge": 833
  },
  {
    "id": 24,
    "description": "Belarus",
    "sigla": "BY",
    "ibge": 850
  },
  {
    "id": 26,
    "description": "Belize",
    "sigla": "BZ",
    "ibge": 884
  },
  {
    "id": 27,
    "description": "Benin",
    "sigla": "BJ",
    "ibge": 2291
  },
  {
    "id": 28,
    "description": "Bermuda",
    "sigla": "BM",
    "ibge": 906
  },
  {
    "id": 29,
    "description": "Bolivia",
    "sigla": "BO",
    "ibge": 973
  },
  {
    "id": 31,
    "description": "Botsuana",
    "sigla": "BW",
    "ibge": 1015
  },
  {
    "id": 1,
    "description": "Brasil",
    "sigla": "BR",
    "ibge": 1058
  },
  {
    "id": 32,
    "description": "Brunei",
    "sigla": "BN",
    "ibge": 1082
  },
  {
    "id": 33,
    "description": "Bulgaria",
    "sigla": "BG",
    "ibge": 1112
  },
  {
    "id": 34,
    "description": "Burkina Faso",
    "sigla": "BF",
    "ibge": 310
  },
  {
    "id": 35,
    "description": "Burundi",
    "sigla": "BI",
    "ibge": 1155
  },
  {
    "id": 36,
    "description": "Butão",
    "sigla": "BT",
    "ibge": 1198
  },
  {
    "id": 25,
    "description": "Bélgica",
    "sigla": "BE",
    "ibge": 876
  },
  {
    "id": 30,
    "description": "Bósnia e Herzegovina",
    "sigla": "BA",
    "ibge": 981
  },
  {
    "id": 37,
    "description": "Cabo Verde",
    "sigla": "CV",
    "ibge": 1279
  },
  {
    "id": 38,
    "description": "Camarões",
    "sigla": "CM",
    "ibge": 1457
  },
  {
    "id": 39,
    "description": "Camboja",
    "sigla": "KH",
    "ibge": 1414
  },
  {
    "id": 40,
    "description": "Canadá",
    "sigla": "CA",
    "ibge": 1490
  },
  {
    "id": 41,
    "description": "Catar",
    "sigla": "QA",
    "ibge": 1546
  },
  {
    "id": 42,
    "description": "Cazaquistão",
    "sigla": "KZ",
    "ibge": 1538
  },
  {
    "id": 43,
    "description": "Chade",
    "sigla": "TD",
    "ibge": 7889
  },
  {
    "id": 44,
    "description": "Chile",
    "sigla": "CL",
    "ibge": 1589
  },
  {
    "id": 45,
    "description": "China",
    "sigla": "CN",
    "ibge": 1600
  },
  {
    "id": 46,
    "description": "China(Hong-Kong)",
    "sigla": "HK",
    "ibge": 3514
  },
  {
    "id": 47,
    "description": "Chipre",
    "sigla": "CY",
    "ibge": 1635
  },
  {
    "id": 48,
    "description": "Cidade do Vaticano (Santa Sé)",
    "sigla": "VA",
    "ibge": 8486
  },
  {
    "id": 49,
    "description": "Cingapura",
    "sigla": "SG",
    "ibge": 7412
  },
  {
    "id": 50,
    "description": "Colombia",
    "sigla": "CO",
    "ibge": 1694
  },
  {
    "id": 51,
    "description": "Comores",
    "sigla": "KM",
    "ibge": 1732
  },
  {
    "id": 52,
    "description": "Congo",
    "sigla": "CG",
    "ibge": 1775
  },
  {
    "id": 53,
    "description": "Coréia",
    "sigla": "KR",
    "ibge": 1902
  },
  {
    "id": 54,
    "description": "Coréia (RDP)",
    "sigla": "KP",
    "ibge": 1872
  },
  {
    "id": 56,
    "description": "Costa Rica",
    "sigla": "CR",
    "ibge": 1961
  },
  {
    "id": 55,
    "description": "Costa do Marfim",
    "sigla": "CI",
    "ibge": 1937
  },
  {
    "id": 57,
    "description": "Croácia (Hrvatska)",
    "sigla": "HR",
    "ibge": 1953
  },
  {
    "id": 58,
    "description": "Cuba",
    "sigla": "CU",
    "ibge": 1996
  },
  {
    "id": 59,
    "description": "Dinamarca",
    "sigla": "DK",
    "ibge": 2321
  },
  {
    "id": 60,
    "description": "Djibuti",
    "sigla": "DJ",
    "ibge": 7838
  },
  {
    "id": 61,
    "description": "Dominica",
    "sigla": "DM",
    "ibge": 2356
  },
  {
    "id": 62,
    "description": "Egito",
    "sigla": "EG",
    "ibge": 2402
  },
  {
    "id": 63,
    "description": "El Salvador",
    "sigla": "SV",
    "ibge": 6874
  },
  {
    "id": 64,
    "description": "Emirados Arabes Unidos",
    "sigla": "AE",
    "ibge": 2445
  },
  {
    "id": 65,
    "description": "Equador",
    "sigla": "EC",
    "ibge": 2399
  },
  {
    "id": 66,
    "description": "Eritréia",
    "sigla": "ER",
    "ibge": 2437
  },
  {
    "id": 239,
    "description": "Escócia",
    "sigla": "UK",
    "ibge": 6289
  },
  {
    "id": 67,
    "description": "Eslovenia",
    "sigla": "SI",
    "ibge": 2461
  },
  {
    "id": 68,
    "description": "Espanha",
    "sigla": "ES",
    "ibge": 2453
  },
  {
    "id": 69,
    "description": "Estados Unidos",
    "sigla": "US",
    "ibge": 2496
  },
  {
    "id": 70,
    "description": "Estônia",
    "sigla": "EE",
    "ibge": 2518
  },
  {
    "id": 71,
    "description": "Etiópia",
    "sigla": "ET",
    "ibge": 2534
  },
  {
    "id": 72,
    "description": "Fiji",
    "sigla": "FJ",
    "ibge": 8702
  },
  {
    "id": 73,
    "description": "Filipinas",
    "sigla": "PH",
    "ibge": 2674
  },
  {
    "id": 74,
    "description": "Finlândia",
    "sigla": "FI",
    "ibge": 2712
  },
  {
    "id": 75,
    "description": "França",
    "sigla": "FR",
    "ibge": 2755
  },
  {
    "id": 76,
    "description": "Gabão",
    "sigla": "GA",
    "ibge": 2810
  },
  {
    "id": 77,
    "description": "Gambia",
    "sigla": "GM",
    "ibge": 2852
  },
  {
    "id": 78,
    "description": "Gana",
    "sigla": "GH",
    "ibge": 2895
  },
  {
    "id": 79,
    "description": "Geórgia",
    "sigla": "GE",
    "ibge": 2917
  },
  {
    "id": 80,
    "description": "Gibraltar",
    "sigla": "GI",
    "ibge": 2933
  },
  {
    "id": 82,
    "description": "Grenada",
    "sigla": "GD",
    "ibge": 2976
  },
  {
    "id": 83,
    "description": "Groenlândia",
    "sigla": "GL",
    "ibge": 3050
  },
  {
    "id": 81,
    "description": "Grécia",
    "sigla": "GR",
    "ibge": 3018
  },
  {
    "id": 84,
    "description": "Guadalupe",
    "sigla": "GP",
    "ibge": 3093
  },
  {
    "id": 85,
    "description": "Guam",
    "sigla": "GU",
    "ibge": 3131
  },
  {
    "id": 86,
    "description": "Guatemala",
    "sigla": "GT",
    "ibge": 3174
  },
  {
    "id": 87,
    "description": "Guiana",
    "sigla": "GY",
    "ibge": 3379
  },
  {
    "id": 88,
    "description": "Guiana Francesa",
    "sigla": "GF",
    "ibge": 3255
  },
  {
    "id": 89,
    "description": "Guiné",
    "sigla": "GN",
    "ibge": 3298
  },
  {
    "id": 90,
    "description": "Guiné Equatorial",
    "sigla": "GQ",
    "ibge": 3310
  },
  {
    "id": 91,
    "description": "Guiné-Bissau",
    "sigla": "GW",
    "ibge": 3344
  },
  {
    "id": 92,
    "description": "Haiti",
    "sigla": "HT",
    "ibge": 3417
  },
  {
    "id": 93,
    "description": "Holanda",
    "sigla": "NL",
    "ibge": 5738
  },
  {
    "id": 94,
    "description": "Honduras",
    "sigla": "HN",
    "ibge": 3450
  },
  {
    "id": 95,
    "description": "Hungria",
    "sigla": "HU",
    "ibge": 3557
  },
  {
    "id": 97,
    "description": "Ilha Bouvet",
    "sigla": "BV",
    "ibge" : 0
  },
  {
    "id": 99,
    "description": "Ilhas Cayman",
    "sigla": "KY",
    "ibge": 1376
  },
  {
    "id": 100,
    "description": "Ilhas Christmas",
    "sigla": "CX",
    "ibge": 5118
  },
  {
    "id": 101,
    "description": "Ilhas Cocos (Keeling)",
    "sigla": "CC",
    "ibge": 1651
  },
  {
    "id": 102,
    "description": "Ilhas Cook",
    "sigla": "CK",
    "ibge": 1830
  },
  {
    "id": 103,
    "description": "Ilhas Faroés",
    "sigla": "FO",
    "ibge": 2593
  },
  {
    "id": 104,
    "description": "Ilhas Geórgia do Sul",
    "sigla": "GS",
    "ibge" : 0
  },
  {
    "id": 105,
    "description": "Ilhas Heard e McDonald",
    "sigla": "HM",
    "ibge" : 0
  },
  {
    "id": 106,
    "description": "Ilhas Malvinas",
    "sigla": "FK",
    "ibge": 2550
  },
  {
    "id": 107,
    "description": "Ilhas Marianas do Norte",
    "sigla": "MP",
    "ibge": 4723
  },
  {
    "id": 108,
    "description": "Ilhas Marshall",
    "sigla": "MH",
    "ibge": 4766
  },
  {
    "id": 109,
    "description": "Ilhas Salomão",
    "sigla": "SB",
    "ibge": 6777
  },
  {
    "id": 110,
    "description": "Ilhas Svalbard e Jan Mayen",
    "sigla": "SJ",
    "ibge" : 0
  },
  {
    "id": 111,
    "description": "Ilhas Turks e Caicos",
    "sigla": "TC",
    "ibge": 8230
  },
  {
    "id": 112,
    "description": "Ilhas Virgens Americanas",
    "sigla": "VI",
    "ibge": 8664
  },
  {
    "id": 113,
    "description": "Ilhas Virgens Britânicas",
    "sigla": "VG",
    "ibge": 8630
  },
  {
    "id": 114,
    "description": "Ilhas Wallis e Futuna",
    "sigla": "WF",
    "ibge": 8753
  },
  {
    "id": 116,
    "description": "Indonésia",
    "sigla": "ID",
    "ibge": 3654
  },
  {
    "id": 240,
    "description": "Inglaterra",
    "sigla": "UK",
    "ibge": 6289
  },
  {
    "id": 118,
    "description": "Iraque",
    "sigla": "IQ",
    "ibge": 3697
  },
  {
    "id": 119,
    "description": "Irlanda",
    "sigla": "IE",
    "ibge": 3751
  },
  {
    "id": 241,
    "description": "Irlanda do Norte",
    "sigla": "UK",
    "ibge": 6289
  },
  {
    "id": 117,
    "description": "Irã",
    "sigla": "IR",
    "ibge": 3727
  },
  {
    "id": 120,
    "description": "Islandia",
    "sigla": "IS",
    "ibge": 3794
  },
  {
    "id": 121,
    "description": "Israel",
    "sigla": "IL",
    "ibge": 3832
  },
  {
    "id": 122,
    "description": "Itália",
    "sigla": "IT",
    "ibge": 3867
  },
  {
    "id": 123,
    "description": "Iugoslávia",
    "sigla": "YU",
    "ibge": 3883
  },
  {
    "id": 96,
    "description": "Iêmen",
    "sigla": "YE",
    "ibge": 3573
  },
  {
    "id": 124,
    "description": "Jamaica",
    "sigla": "JM",
    "ibge": 3913
  },
  {
    "id": 125,
    "description": "Japão",
    "sigla": "JP",
    "ibge": 3999
  },
  {
    "id": 126,
    "description": "Jordânia",
    "sigla": "JO",
    "ibge": 4030
  },
  {
    "id": 127,
    "description": "Kiribati",
    "sigla": "KI",
    "ibge": 4111
  },
  {
    "id": 128,
    "description": "Kuwait",
    "sigla": "KW",
    "ibge": 1988
  },
  {
    "id": 129,
    "description": "Laos",
    "sigla": "LA",
    "ibge": 4200
  },
  {
    "id": 130,
    "description": "Lesoto",
    "sigla": "LS",
    "ibge": 4260
  },
  {
    "id": 131,
    "description": "Letônia",
    "sigla": "LV",
    "ibge": 4278
  },
  {
    "id": 133,
    "description": "Libéria",
    "sigla": "LR",
    "ibge": 4340
  },
  {
    "id": 135,
    "description": "Liechtenstein",
    "sigla": "LI",
    "ibge": 4405
  },
  {
    "id": 136,
    "description": "Lituânia",
    "sigla": "LT",
    "ibge": 4421
  },
  {
    "id": 137,
    "description": "Luxemburgo",
    "sigla": "LU",
    "ibge": 4456
  },
  {
    "id": 132,
    "description": "Líbano",
    "sigla": "LB",
    "ibge": 4316
  },
  {
    "id": 134,
    "description": "Líbia",
    "sigla": "LY",
    "ibge": 4383
  },
  {
    "id": 138,
    "description": "Macau",
    "sigla": "MO",
    "ibge": 4472
  },
  {
    "id": 139,
    "description": "Macedônia",
    "sigla": "MK",
    "ibge": 4499
  },
  {
    "id": 140,
    "description": "Madagascar",
    "sigla": "MG",
    "ibge": 4502
  },
  {
    "id": 142,
    "description": "Malaui",
    "sigla": "MW",
    "ibge": 4588
  },
  {
    "id": 143,
    "description": "Maldivas",
    "sigla": "MV",
    "ibge": 4618
  },
  {
    "id": 144,
    "description": "Mali",
    "sigla": "ML",
    "ibge": 4642
  },
  {
    "id": 145,
    "description": "Malta",
    "sigla": "MT",
    "ibge": 4677
  },
  {
    "id": 141,
    "description": "Malásia",
    "sigla": "MY",
    "ibge": 4553
  },
  {
    "id": 146,
    "description": "Marrocos",
    "sigla": "MA",
    "ibge": 4740
  },
  {
    "id": 147,
    "description": "Martinica",
    "sigla": "MQ",
    "ibge": 4774
  },
  {
    "id": 149,
    "description": "Mauritânia",
    "sigla": "MR",
    "ibge": 4880
  },
  {
    "id": 148,
    "description": "Maurício",
    "sigla": "MU",
    "ibge": 4855
  },
  {
    "id": 150,
    "description": "Mayotte",
    "sigla": "YT",
    "ibge" : 0
  },
  {
    "id": 152,
    "description": "Micronésia",
    "sigla": "FM",
    "ibge": 4995
  },
  {
    "id": 154,
    "description": "Moldávia",
    "sigla": "MD",
    "ibge": 4944
  },
  {
    "id": 156,
    "description": "Mongólia",
    "sigla": "MN",
    "ibge": 4979
  },
  {
    "id": 157,
    "description": "Montserrat",
    "sigla": "MS",
    "ibge": 5010
  },
  {
    "id": 153,
    "description": "Moçambique",
    "sigla": "MZ",
    "ibge": 5053
  },
  {
    "id": 158,
    "description": "Myanma",
    "sigla": "MM",
    "ibge": 930
  },
  {
    "id": 151,
    "description": "México",
    "sigla": "MX",
    "ibge": 4936
  },
  {
    "id": 155,
    "description": "Mônaco",
    "sigla": "MC",
    "ibge": 4952
  },
  {
    "id": 159,
    "description": "Namíbia",
    "sigla": "NA",
    "ibge": 5070
  },
  {
    "id": 999,
    "description": "Nao Informado",
    "sigla": "99",
    "ibge" : 0
  },
  {
    "id": 160,
    "description": "Nauru",
    "sigla": "NR",
    "ibge": 5088
  },
  {
    "id": 161,
    "description": "Nepal",
    "sigla": "NP",
    "ibge": 5177
  },
  {
    "id": 162,
    "description": "Nicarágua",
    "sigla": "NI",
    "ibge": 5215
  },
  {
    "id": 164,
    "description": "Nigéria",
    "sigla": "NG",
    "ibge": 5282
  },
  {
    "id": 165,
    "description": "Niue",
    "sigla": "NU",
    "ibge": 5312
  },
  {
    "id": 98,
    "description": "Norfolk",
    "sigla": "NF",
    "ibge": 5355
  },
  {
    "id": 166,
    "description": "Noruega",
    "sigla": "NO",
    "ibge": 5380
  },
  {
    "id": 167,
    "description": "Nova Caledônia",
    "sigla": "NC",
    "ibge": 5428
  },
  {
    "id": 168,
    "description": "Nova Zelândia",
    "sigla": "NZ",
    "ibge": 5487
  },
  {
    "id": 163,
    "description": "Níger",
    "sigla": "NE",
    "ibge": 5258
  },
  {
    "id": 169,
    "description": "Omã",
    "sigla": "OM",
    "ibge": 5568
  },
  {
    "id": 170,
    "description": "Palau",
    "sigla": "PW",
    "ibge": 5754
  },
  {
    "id": 171,
    "description": "Panamá",
    "sigla": "PA",
    "ibge": 5800
  },
  {
    "id": 172,
    "description": "Papua-Nova Guiné",
    "sigla": "PG",
    "ibge": 5452
  },
  {
    "id": 173,
    "description": "Paquistão",
    "sigla": "PK",
    "ibge": 5762
  },
  {
    "id": 174,
    "description": "Paraguai",
    "sigla": "PY",
    "ibge": 5860
  },
  {
    "id": 242,
    "description": "País de Gales",
    "sigla": "UK",
    "ibge": 6289
  },
  {
    "id": 175,
    "description": "Peru",
    "sigla": "PE",
    "ibge": 5894
  },
  {
    "id": 176,
    "description": "Pitcairn",
    "sigla": "PN",
    "ibge": 5932
  },
  {
    "id": 177,
    "description": "Polinésia Francesa",
    "sigla": "PF",
    "ibge": 5991
  },
  {
    "id": 178,
    "description": "Polônia",
    "sigla": "PL",
    "ibge": 6033
  },
  {
    "id": 179,
    "description": "Porto Rico",
    "sigla": "PR",
    "ibge": 6114
  },
  {
    "id": 180,
    "description": "Portugal",
    "sigla": "PT",
    "ibge": 6076
  },
  {
    "id": 182,
    "description": "Quirguistão",
    "sigla": "KG",
    "ibge": 6254
  },
  {
    "id": 181,
    "description": "Quênia",
    "sigla": "KE",
    "ibge": 6238
  },
  {
    "id": 183,
    "description": "Reino Unido",
    "sigla": "UK",
    "ibge": 6289
  },
  {
    "id": 184,
    "description": "República Centro-Africana",
    "sigla": "CF",
    "ibge": 6408
  },
  {
    "id": 185,
    "description": "República Dominicana",
    "sigla": "DO",
    "ibge": 6475
  },
  {
    "id": 186,
    "description": "República Eslovaca",
    "sigla": "SK",
    "ibge": 2470
  },
  {
    "id": 187,
    "description": "República Popular do Congo (Zaire)",
    "sigla": "CD",
    "ibge": 8885
  },
  {
    "id": 188,
    "description": "República Tcheca",
    "sigla": "CZ",
    "ibge": 7919
  },
  {
    "id": 189,
    "description": "Reunião",
    "sigla": "RE",
    "ibge": 6602
  },
  {
    "id": 190,
    "description": "Romênia",
    "sigla": "RO",
    "ibge": 6700
  },
  {
    "id": 191,
    "description": "Ruanda",
    "sigla": "RW",
    "ibge": 6750
  },
  {
    "id": 192,
    "description": "Rússia",
    "sigla": "RU",
    "ibge": 6769
  },
  {
    "id": 193,
    "description": "Saara Ocidental",
    "sigla": "EH",
    "ibge": 6858
  },
  {
    "id": 194,
    "description": "Saint Kitts e Névis",
    "sigla": "KN",
    "ibge": 6781
  },
  {
    "id": 195,
    "description": "Samoa",
    "sigla": "WS",
    "ibge": 6904
  },
  {
    "id": 196,
    "description": "Samoa Americana",
    "sigla": "AS",
    "ibge": 6912
  },
  {
    "id": 197,
    "description": "San Marino",
    "sigla": "SM",
    "ibge": 6971
  },
  {
    "id": 198,
    "description": "Santa Helena",
    "sigla": "SH",
    "ibge": 7102
  },
  {
    "id": 199,
    "description": "Santa Lúcia",
    "sigla": "LC",
    "ibge": 7153
  },
  {
    "id": 202,
    "description": "Senegal",
    "sigla": "SN",
    "ibge": 7285
  },
  {
    "id": 203,
    "description": "Serra Leoa",
    "sigla": "SL",
    "ibge": 7358
  },
  {
    "id": 204,
    "description": "Seychelles",
    "sigla": "SC",
    "ibge": 7315
  },
  {
    "id": 206,
    "description": "Somália",
    "sigla": "SO",
    "ibge": 7480
  },
  {
    "id": 207,
    "description": "Sri Lanka",
    "sigla": "LK",
    "ibge": 7501
  },
  {
    "id": 208,
    "description": "St. Pierre e Miquelon",
    "sigla": "PM",
    "ibge": 7005
  },
  {
    "id": 209,
    "description": "Suazilândia",
    "sigla": "SZ",
    "ibge": 7544
  },
  {
    "id": 210,
    "description": "Sudão",
    "sigla": "SD",
    "ibge": 7595
  },
  {
    "id": 213,
    "description": "Suriname",
    "sigla": "SR",
    "ibge": 7706
  },
  {
    "id": 211,
    "description": "Suécia",
    "sigla": "SE",
    "ibge": 7641
  },
  {
    "id": 212,
    "description": "Suíça",
    "sigla": "CH",
    "ibge": 7676
  },
  {
    "id": 200,
    "description": "São Tomé e Príncipe",
    "sigla": "ST",
    "ibge": 7200
  },
  {
    "id": 201,
    "description": "São Vicente e Granadinas",
    "sigla": "VC",
    "ibge": 7056
  },
  {
    "id": 205,
    "description": "Síria",
    "sigla": "SY",
    "ibge": 7447
  },
  {
    "id": 214,
    "description": "Tadjiquistão",
    "sigla": "TJ",
    "ibge": 7722
  },
  {
    "id": 215,
    "description": "Tailândia",
    "sigla": "TH",
    "ibge": 7765
  },
  {
    "id": 216,
    "description": "Taiwan",
    "sigla": "TW",
    "ibge": 1619
  },
  {
    "id": 217,
    "description": "Tanzânia",
    "sigla": "TZ",
    "ibge": 7803
  },
  {
    "id": 218,
    "description": "Território Britânico do Oceano Índico",
    "sigla": "IO",
    "ibge": 7820
  },
  {
    "id": 219,
    "description": "Territórios Franceses do Sul",
    "sigla": "TF",
    "ibge" : 0
  },
  {
    "id": 220,
    "description": "Territórios Insulares dos EUA",
    "sigla": "UM",
    "ibge" : 0
  },
  {
    "id": 221,
    "description": "Timor Oriental",
    "sigla": "TP",
    "ibge": 7951
  },
  {
    "id": 222,
    "description": "Togo",
    "sigla": "TG",
    "ibge": 8001
  },
  {
    "id": 223,
    "description": "Tokelau",
    "sigla": "TK",
    "ibge": 8052
  },
  {
    "id": 224,
    "description": "Tonga",
    "sigla": "TO",
    "ibge": 8109
  },
  {
    "id": 225,
    "description": "Trinidad e Tobago",
    "sigla": "TT",
    "ibge": 8150
  },
  {
    "id": 226,
    "description": "Tunísia",
    "sigla": "TN",
    "ibge": 8206
  },
  {
    "id": 227,
    "description": "Turcomenistão",
    "sigla": "TM",
    "ibge": 8249
  },
  {
    "id": 228,
    "description": "Turquia",
    "sigla": "TR",
    "ibge": 8273
  },
  {
    "id": 229,
    "description": "Tuvalu",
    "sigla": "TV",
    "ibge": 8281
  },
  {
    "id": 230,
    "description": "Ucrânia",
    "sigla": "UA",
    "ibge": 8311
  },
  {
    "id": 231,
    "description": "Uganda",
    "sigla": "UG",
    "ibge": 8338
  },
  {
    "id": 232,
    "description": "Uruguai",
    "sigla": "UY",
    "ibge": 8451
  },
  {
    "id": 233,
    "description": "Uzbequistão",
    "sigla": "UZ",
    "ibge": 8478
  },
  {
    "id": 234,
    "description": "Vanuatu",
    "sigla": "VU",
    "ibge": 5517
  },
  {
    "id": 235,
    "description": "Venezuela",
    "sigla": "VE",
    "ibge": 8508
  },
  {
    "id": 236,
    "description": "Vietnã",
    "sigla": "VN",
    "ibge": 8583
  },
  {
    "id": 238,
    "description": "Zimbábue",
    "sigla": "ZW",
    "ibge": 6653
  },
  {
    "id": 237,
    "description": "Zâmbia",
    "sigla": "ZM",
    "ibge": 8907
  },
  {
    "id": 115,
    "description": "Índia",
    "sigla": "IN",
    "ibge": 3611
  }
]
